class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    $('.cart-remove-icon').click(function(e){
      e.preventDefault();
      let removeItem = this.dataset.cartremove;
      let cartDrawer = document.querySelector('cart-drawer');
      if(document.getElementById(removeItem)){
      document.getElementById(removeItem).classList.add('show'); 
    }
      cartDrawer.classList.remove('active');
      removeTrapFocus(cartDrawer.activeElement);
      });

      $('.wishlist_test_btn').click(function(e){
        e.preventDefault();
        $(this).siblings('.swym-button.swym-add-to-wishlist-view-product').click();
        $(this).siblings('cart-remove-popup').click();
        });

      document.addEventListener('pincode:updated', () => {
        this.refresh();
      });
  }

  refresh() {
    const cartDrawer = this;

    const sections = cartDrawer.getSectionsToRender()
      .map(section => section.id)
      .join(',');

    fetch(`${window.Shopify.routes.root}?sections=${sections}`)
      .then(res => res.json())
      .then(sectionsHtml => {
        cartDrawer.getSectionsToRender().forEach(section => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement) return;

          sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(
            sectionsHtml[section.id],
            section.selector
          );
        });
      })
      .catch(err => console.error('Cart drawer refresh failed', err));
  }


  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    document.body.setAttribute('overflow','hidden');
    document.body.classList.add('overflow-hidden');
             document.body.style.overflow = "hidden";

    
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.removeAttribute('overflow');
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = "scroll";
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

    renderContents(parsedState, button_event) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    

    let cart_remove_section_url = window.Shopify.routes.root + '?sections=cart-remove-popup';
  $.ajax({
      url: cart_remove_section_url,
      type: "GET",
      dataType: "json",
      success: function(e) {
          let responce = e['cart-remove-popup'];
        let cart_remove_section_html = $(responce).find(".cart-remove-popup_container .js-contents").html();
          $('.cart-remove-popup_container .js-contents').html(cart_remove_section_html);
          document.querySelector('body').classList.remove('overflow-hidden');
          document.body.removeAttribute('overflow');
      }
  })

    $('.cart-remove-icon').click(function(e){
      e.preventDefault();
      let removeItem = this.dataset.cartremove;
      let cartDrawer = document.querySelector('cart-drawer');
      if(document.getElementById(removeItem)){
      document.getElementById(removeItem).classList.add('show'); 
    }
      cartDrawer.classList.remove('active');
      removeTrapFocus(cartDrawer.activeElement);
      });

      $('.wishlist_test_btn').click(function(e){
        e.preventDefault();
        $(this).siblings('.swym-button.swym-add-to-wishlist-view-product').click();
        $(this).siblings('cart-remove-popup').click();
        });

    setTimeout(() => {
      // if(button_event.classList.contains('custom_buy_now')){
      //   this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      //   this.open();
      // }else{
      //   let show_title = parsedState.product_title;

      //   if(parsedState.variant_title!=null){
      //       show_title = `${parsedState.product_title} ${parsedState.variant_title}`;
      //   }

      //   $('.atc_notification .pname').text(show_title);
      //   $('.atc_notification').addClass('show');
      //   setTimeout(function(){
      //     $('.atc_notification').removeClass('show');
      //     $('.atc_notification .pname').text('');
      //   }, 3000);
      // }

      // Add to Cart -> Open Drawer
      if (!button_event.classList.contains('custom_buy_now')) {
          this.querySelector('#CartDrawer-Overlay').addEventListener(
              'click',
              this.close.bind(this)
          );

          this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


